export default "__VITE_ASSET__BmTEP3bd__"